interface RankingItem {
  rank: number;
  title: string;
  category: string;
  hot: string;
  change: 'up' | 'down' | 'new' | 'same';
}

const rankings: RankingItem[] = [
  { rank: 1, title: '鬼灭之刃 无限城篇', category: '热血战斗', hot: '🔥 986万', change: 'up' },
  { rank: 2, title: '葬送的芙莉莲 第二季', category: '奇幻治愈', hot: '🔥 872万', change: 'same' },
  { rank: 3, title: '咒术回战 死灭回游', category: '黑暗奇幻', hot: '🔥 815万', change: 'up' },
  { rank: 4, title: '我推的孩子 第三季', category: '悬疑偶像', hot: '🔥 753万', change: 'new' },
  { rank: 5, title: '药屋少女的呢喃 第二季', category: '宫廷推理', hot: '🔥 691万', change: 'down' },
];

const changeIcon = (c: RankingItem['change']) => {
  if (c === 'up') return <i className="ri-arrow-up-line text-green-500 text-sm"></i>;
  if (c === 'down') return <i className="ri-arrow-down-line text-red-400 text-sm"></i>;
  if (c === 'new') return <span className="text-xs text-accent-600 font-medium whitespace-nowrap">NEW</span>;
  return <i className="ri-subtract-line text-foreground-300 text-sm"></i>;
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热度榜单</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">当前91樱花用户最关注的动漫作品排行，数据实时更新</p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankings.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 px-5 py-4 ${
                idx < rankings.length - 1 ? 'border-b border-background-200/60' : ''
              } hover:bg-background-100 transition-colors duration-200`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-base ${
                item.rank === 1
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-100 text-primary-600'
                  : item.rank === 3
                  ? 'bg-secondary-100 text-secondary-600'
                  : 'bg-background-200 text-foreground-400'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-400">{item.category}</span>
              </div>

              <span className="text-sm text-foreground-600 font-medium whitespace-nowrap">{item.hot}</span>

              <span className="w-6 flex items-center justify-center">{changeIcon(item.change)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}